import axios from './axios'
import config from '../config'

export default {
    listUserGroups(params) {
        return axios({
            url: config.backendUrl + '/common/admin/user-groups',
            method: 'GET',
            params
        })
    },
    addUserGroup(data) {
        return axios({
            url: config.backendUrl + '/common/admin/user-groups',
            method: 'POST',
            data
        })
    },
    updateUserGroup({id, data}) {
        return axios({
            url: config.backendUrl + '/common/admin/user-groups/' + id,
            method: 'PUT',
            data
        })
    },
    getUserGroup(id) {
        return axios({
            url: config.backendUrl + '/common/admin/user-groups/' + id,
            method: 'GET'
        })
    },
    deleteUserGroup(id) {
        return axios({
            url: config.backendUrl + '/common/admin/user-groups/' + id,
            method: 'DELETE'
        })
    },
    checkUserGroupName(name) {
        return axios({
            url: config.backendUrl + '/common/admin/user-groups/check-name',
            method: 'GET',
            params: {name}
        })
    }
}
